// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cf497017","977":"1ef88b33"}[chunkId] + ".chunk.js";
};